import {
  mdiClockOutline,
  mdiClose,
  mdiDelete,
  mdiFloppy,
  mdiPencil,
  mdiPlus,
  mdiTimer,
  mdiAbacus,
  mdiRocketLaunch,
  mdiClockAlert,
} from '@mdi/js'

export const vuetifyOptions = {
  defaults: {
    VSnackbar: {
      location: 'bottom right',
      timeout: '4000',
    },
  },
  icons: {
    aliases: {
      timer: mdiClockOutline,
      timerSecondary: mdiTimer,
      plus: mdiPlus,
      edit: mdiPencil,
      save: mdiFloppy,
      cancel: mdiClose,
      delete: mdiDelete,
      abacus: mdiAbacus,
      rocketLaunch: mdiRocketLaunch,
      clockAlert: mdiClockAlert,
    },
  },
}
